export default {"src":"/_next/static/media/mission.36168807.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};